import axios from "axios";
import { del, get, post, patch,  put } from "./anonymous_exam_records_api_helper";
import * as url from "./anonymous_exam_records_url_helper";





// Get Anonymous exam records
export const getAnonymousExamRecords = (evaluation_uuid, ...filters ) => get(`${url.GET_ANONYMOUS_EXAM_RECORDS}/evaluation/${evaluation_uuid}`, { params: filters });



export const addNewAnonymousExamRecord = (anonymousExamRecord) => post(url.ADD_NEW_ANONYMOUS_EXAM_RECORD, anonymousExamRecord);



//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateAnonymousExamRecord = (anonymousExamRecord) => patch(`${url.UPDATE_ANONYMOUS_EXAM_RECORD}/${anonymousExamRecord.id}`,  anonymousExamRecord);


export const deleteAnonymousExamRecord = (anonymousExamRecord) => del(`${url.DELETE_ANONYMOUS_EXAM_RECORD}/${anonymousExamRecord.id}`);


export const getAnonymousExamRecordsForTeacher = (filters) => get(url.GET_ANONYMOUS_EXAM_RECORDS_FOR_TEACHER, { params: filters });



// LAST ADD FOR SEARCH BY BARCODE


// Rechercher un enregistrement anonyme par code-barre
export const getAnonymousExamRecordByBarcode = (barcode) => get(`${url.GET_ANONYMOUS_RECORD_BY_BARCODE}/${barcode}`);

// Mettre à jour la note d'un enregistrement anonyme
export const updateAnonymousExamRecordNote = (data) => put(`${url.UPDATE_ANONYMOUS_RECORD_NOTE}/${data.uuid}/note`, {note_value: data.note_value});


// Remplace le nom de la fonction par celui que tu appelles dans ta Saga
// ... tes autres exports
export const generateAnonymousRecords = (uuid) => post(`${url.GENERATE_ANONYMOUS_RECORDS}/${uuid}/generate-anonymous-records`);



export {
    //getLoggedInUser,
  
};
